import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/dashboard/messages/components/messages-shell.tsx");
